module.exports = __webpack_public_path__ + "img/1.88e7d1ce.jpg";